import { html } from 'lit';
import { ThumbsUp } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-thumbs-up')
export class PdsIconThumbsUp extends PdsIcon {
  @state()
  icon = ThumbsUp;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
